var exports = {
  "U": "AddCommentEditor__k2fHUK",
};

module.exports = exports;
